import api from "./api";
import merge from "lodash/merge";
import config from "../config";

export default {
  check(person, code, order) {
    return new Promise((resolve, reject) => {
      if (!code) {
        return reject(new Error("A code must be entered."));
      }

      order = merge({}, order, { token: person, coupon: null, name: null });

      api.request(
        {
          method: "POST",
          endpoint: `coupons/test`,
          json: {
            token: person,
            code: code,
            order: JSON.stringify(order),
            event_bucket: config.event_bucket
          }
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  }
};



// WEBPACK FOOTER //
// ./src/app/utils/CouponUtil.js